import React from 'react';
import { Trans } from 'react-i18next';

import image from './image';

const imageWithSettings = {
    type: 'object',
    properties: {
        ...image.properties,
        settings: {
            type: 'object',
            title: null,
            properties: {
                size: {
                    type: 'string',
                    enum: [
                        'small',
                        'medium',
                        'large'
                    ],
                    enumNames: [
                        <Trans ns="dm.article" i18nKey="search-card_small">Liten</Trans>,
                        <Trans ns="dm.article" i18nKey="search-card_medium">Medium</Trans>,
                        <Trans ns="dm.article" i18nKey="search-card_large">Stor</Trans>
                    ],
                    default: 'medium'
                }
            }
        }
    }
};

export default imageWithSettings;
